import React from "react";
import ReactDOM from "react-dom";
import Newsletter from "./Newsletter";

ReactDOM.render(
  <React.StrictMode>
    <Newsletter />
  </React.StrictMode>,
  document.getElementById("root")
);
